/**
 * Used to calculated the total sum per column of the abandoned type report
 */
export function formatAbandonedCallsData({ rawData = [] } = {}) {
  const totals = {
    tramo: "Total",
    ene: 0,
    feb: 0,
    mar: 0,
    abr: 0,
    may: 0,
    jun: 0,
    jul: 0,
    ago: 0,
    sep: 0,
    oct: 0,
    nov: 0,
    dic: 0,
  };

  rawData.forEach((item) => {
    totals.ene += item.ene;
    totals.feb += item.feb;
    totals.mar += item.mar;
    totals.abr += item.abr;
    totals.may += item.may;
    totals.jun += item.jun;
    totals.jul += item.jul;
    totals.ago += item.ago;
    totals.sep += item.sep;
    totals.oct += item.oct;
    totals.nov += item.nov;
    totals.dic += item.dic;
  });

  return [...rawData, totals];
}
